var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrstudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9272 2.87437C15.1152 1.04415 12.6495 0.00998664 10.0741 0H10C4.61522 0 0.25 4.36522 0.25 9.75V15C0.25 16.2426 1.25736 17.25 2.5 17.25H4C5.24264 17.25 6.25 16.2426 6.25 15V11.25C6.25 10.0074 5.24264 9 4 9H1.78375C2.17156 4.75177 5.7341 1.49979 10 1.5H10.0628C14.3107 1.51795 17.8457 4.76853 18.2191 9H16C14.7574 9 13.75 10.0074 13.75 11.25V15C13.75 16.2426 14.7574 17.25 16 17.25H17.5C18.7426 17.25 19.75 16.2426 19.75 15V9.75C19.7599 7.17412 18.7442 4.70022 16.9272 2.87437ZM4 10.5C4.41421 10.5 4.75 10.8358 4.75 11.25V15C4.75 15.4142 4.41421 15.75 4 15.75H2.5C2.08579 15.75 1.75 15.4142 1.75 15V10.5H4ZM18.25 15C18.25 15.4142 17.9142 15.75 17.5 15.75H16C15.5858 15.75 15.25 15.4142 15.25 15V11.25C15.25 10.8358 15.5858 10.5 16 10.5H18.25V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrstudio);
export default __webpack_public_path__ + "static/media/urstudio.26e3b7e983597ada2fe55de5160cc74d.svg";
export { ForwardRef as ReactComponent };